import ProviderAPI from "../../src/redux/ProviderAPI";

export const postUploadImage = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/uploadassetprofile/addProfile",
    data,
    token,
  });

  return result;
};

export const getUploadImage = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/uploadassetprofile/detailUploadProfile",
    data,
    token,
  });

  return result;
};

export const postUploadGalleryRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/uploadassetgallery/addGalleryRoom",
    data,
    token,
  });

  return result;
};

export const getUploadGalleryRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/uploadassetgallery/detailUploadGalleryRoom",
    data,
    token,
  });

  return result;
};

export const postUploadGalleryAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/uploadassetgallery/addGalleryNewAsset",
    data,
    token,
  });

  return result;
};

export const getUploadGalleryAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/uploadassetgallery/detailUploadGalleryNewAsset",
    data,
    token,
  });

  return result;
};

export const deleteGalleryAsset = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/uploadassetgallery/deleteGalleryAsset",
    data,
    token,
  });

  return result;
};

export const deleteGalleryRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/uploadassetgallery/deleteGalleryRoom",
    data,
    token,
  });

  return result;
};

export const getGalleryAssetManage = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/uploadassetgallery/resultsGalleryAsset",
    data,
    token,
  });

  return result;
};

export const getProfiles = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/uploadassetprofile/resultsProfile",
    data,
    token,
  });

  return result;
};

export const deleteProfiles = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/uploadassetprofile/deleteProfileRoom",
    data,
    token,
  });

  return result;
};

export const editGalleryRoom = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/uploadassetgallery/editGalleryRoom",
    data,
    token,
  });

  return result;
};

export const editProfiles = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/uploadassetprofile/editProfileRoom",
    data,
    token,
  });

  return result;
};
